/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoomAvailabilityPropertyRequest } from './RoomAvailabilityPropertyRequest';
import {
    RoomAvailabilityPropertyRequestFromJSON,
    RoomAvailabilityPropertyRequestFromJSONTyped,
    RoomAvailabilityPropertyRequestToJSON,
    RoomAvailabilityPropertyRequestToJSONTyped,
} from './RoomAvailabilityPropertyRequest';

/**
 * 
 * @export
 * @interface RoomAvailabilityRequest
 */
export interface RoomAvailabilityRequest {
    /**
     * 
     * @type {Array<RoomAvailabilityPropertyRequest>}
     * @memberof RoomAvailabilityRequest
     */
    properties: Array<RoomAvailabilityPropertyRequest>;
}

/**
 * Check if a given object implements the RoomAvailabilityRequest interface.
 */
export function instanceOfRoomAvailabilityRequest(value: object): value is RoomAvailabilityRequest {
    if (!('properties' in value) || value['properties'] === undefined) return false;
    return true;
}

export function RoomAvailabilityRequestFromJSON(json: any): RoomAvailabilityRequest {
    return RoomAvailabilityRequestFromJSONTyped(json, false);
}

export function RoomAvailabilityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomAvailabilityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'properties': ((json['properties'] as Array<any>).map(RoomAvailabilityPropertyRequestFromJSON)),
    };
}

export function RoomAvailabilityRequestToJSON(json: any): RoomAvailabilityRequest {
    return RoomAvailabilityRequestToJSONTyped(json, false);
}

export function RoomAvailabilityRequestToJSONTyped(value?: RoomAvailabilityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'properties': ((value['properties'] as Array<any>).map(RoomAvailabilityPropertyRequestToJSON)),
    };
}

